import React from 'react';
export function WebinarForm({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`bg-white p-4 rounded-xl shadow-sm border border-[#E6E6E0] ${className}`} data-id="element-4">
      <div className="w-full overflow-hidden rounded-lg bg-gray-50" data-id="element-5">
        <iframe src="https://app.webinargeek.com/embed/343df437-efc3-4c78-9e7c-aa6833652f76?cst=src-meta_cmp-mcu_pt-advertorial-u1" height="550" width="100%" title="Uitvalgedrag Begrijpen, Behandelen" style={{
        border: 0,
        minHeight: '550px'
      }} allowFullScreen data-id="element-6" />
      </div>
      <p className="text-center text-xs text-gray-500 mt-3" data-id="element-7">
        Kies een tijdstip dat jou uitkomt. Beperkt aantal plekken per sessie.
      </p>
    </div>;
}